<script setup lang="ts">
import {
	SwitchRoot,
	type SwitchRootEmits,
	type SwitchRootProps,
	SwitchThumb,
	useForwardPropsEmits,
} from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<SwitchRootProps & { class?: string }>()
const emits = defineEmits<SwitchRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
	<SwitchRoot
		v-bind="forwarded"
		:class="
			cn(
				'focus-visible:ring-ring focus-visible:ring-offset-background data-[state=unchecked]:bg-input peer inline-flex h-[20px] w-[40px] shrink-0 cursor-pointer items-center rounded-full  border-transparent bg-black px-[3px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-o-500',
				props.class,
			)
		"
	>
		<SwitchThumb
			:class="
				cn(
					'pointer-events-none block h-[14px] w-[14px] rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-20px data-[state=unchecked]:translate-x-0',
				)
			"
		/>
	</SwitchRoot>
</template>
